import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useRecipesHook } from '../../../Hooks/communicators/useRecipesHook';
import { useSelector } from 'react-redux';
import UpdateRecipeComponent from './UpdateRecipeComponent';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    height: 'auto',
    minHeight: 300,
    bgcolor: 'white',
    border: '1px solid #000',
    p: 4,
    borderRadius: '10px',
    justifyContent: 'center',
    alignItems: 'center',
};



export default function DeleteRecipe() {
    const [open, setOpen] = useState(false);
    const [selectedRecipeTitle, setSelectedRecipeTitle] = useState('');
    const [selectedRecipeId, setSelectedRecipeId] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const { allRecipes, recipesLoading } = useSelector((state: any) => state.recipe.value);
    const {
        fetchAllRecipes,
        deleteRecipe,
        searchRecipes,
    } = useRecipesHook();
    
    useEffect(() => {
        fetchAllRecipes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (searchQuery.trim() === '') {
            fetchAllRecipes();
        } else if (searchQuery.trim().length >= 3) {
            const delaySearch = setTimeout(() => {
                searchRecipes(searchQuery);
            }, 500); // 500ms debounce

            return () => clearTimeout(delaySearch);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery]);
    if (recipesLoading === true || allRecipes === null) {
        return <div>Loading...</div>
    };
    const handleClose = () => setOpen(false);
    return (
        <div className='flex justify-center items-center flex-col'>
            <h1 className='text-2xl font-bold my-8'>
                Delete Recipe
            </h1>
            
            {/* Search Input */}
            <div className='w-full max-w-2xl my-4 px-4'>
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search recipes... (min. 3 characters)"
                    className='w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                />
                {searchQuery.trim().length > 0 && searchQuery.trim().length < 3 && (
                    <p className='text-sm text-gray-500 mt-1'>Please enter at least 3 characters to search</p>
                )}
            </div>

            {
                allRecipes.map((recipe: any) => {
                    return (
                        // <RecipeListComponent
                        //     mode='delete'
                        //     _id={recipe._id}
                        //     recipeName={recipe.recipeName}
                        //     recipeType={recipe.recipeType}
                        //     recipeTrimester={recipe.recipeTrimester}
                        //     recipePreparationTime={recipe.recipePreparationTime}
                        //     recipeCookTime={recipe.recipeCookTime}
                        //     recipeServes={recipe.recipeServes}
                        //     recipeTags={recipe.recipeTags}
                        //     recipeMethod={recipe.recipeMethod}
                        //     recipeIngredients={recipe.recipeIngredients}
                        //     recipeImage={recipe.recipeImage}
                        //     recipeCarbs={recipe.recipeCarbs}
                        //     recipeProtein={recipe.recipeProtein}
                        //     recipeFats={recipe.recipeFats}
                        //     recipeCalories={recipe.recipeCalories}
                        //     recipeCalcium={recipe.recipeCalcium}
                        //     recipeVitaminA={recipe.recipeVitaminA}
                        //     recipeVitaminB6={recipe.recipeVitaminB6}
                        //     recipeVitaminB12={recipe.recipeVitaminB12}
                        //     recipeVitaminC={recipe.recipeVitaminC}
                        //     recipeVitaminD={recipe.recipeVitaminD}
                        //     recipeVitaminE={recipe.recipeVitaminE}
                        //     recipeVitaminK={recipe.recipeVitaminK}
                        //     recipeVitaminAUnit={recipe.recipeVitaminAUnit}
                        //     recipeVitaminB6Unit={recipe.recipeVitaminB6Unit}
                        //     recipeVitaminB12Unit={recipe.recipeVitaminB12Unit}
                        //     recipeVitaminCUnit={recipe.recipeVitaminCUnit}
                        //     recipeVitaminDUnit={recipe.recipeVitaminDUnit}
                        //     recipeVitaminEUnit={recipe.recipeVitaminEUnit}
                        //     recipeVitaminKUnit={recipe.recipeVitaminKUnit}
                        //     recipeCholesterol={recipe.recipeCholesterol}
                        //     recipeCholesterolUnit={recipe.recipeCholesterolUnit}
                        //     recipeCholine={recipe.recipeCholine}
                        //     recipeCholineUnit={recipe.recipeCholineUnit}
                        //     recipeFiber={recipe.recipeFiber}
                        //     recipeFiberUnit={recipe.recipeFiberUnit}
                        //     recipeFolicAcid={recipe.recipeFolicAcid}
                        //     recipeFolicAcidUnit={recipe.recipeFolicAcidUnit}
                        //     recipeIodine={recipe.recipeIodine}
                        //     recipeIodineUnit={recipe.recipeIodineUnit}
                        //     recipeIron={recipe.recipeIron}
                        //     recipeIronUnit={recipe.recipeIronUnit}
                        //     recipeMagnesium={recipe.recipeMagnesium}
                        //     recipeMagnesiumUnit={recipe.recipeMagnesiumUnit}
                        //     recipePotassium={recipe.recipePotassium}
                        //     recipePotassiumUnit={recipe.recipePotassiumUnit}
                        //     recipeSaturatedFat={recipe.recipeSaturatedFat}
                        //     recipeSaturatedFatUnit={recipe.recipeSatuaratedFatUnit}
                        //     blogReferences={recipe.blogReferences}
                        //     createdAt={recipe.createdAt}
                        //     updatedAt={recipe.updatedAt}
                        //     isPremium={recipe.isPremium}
                        //     isDeleted={recipe.isDeleted}
                        //     isPriority={recipe.isPriority}
                        //     open={open}
                        //     setOpen={setOpen}
                        //     selectedRecipeTitle={selectedRecipeTitle}
                        //     setSelectedRecipeTitle={setSelectedRecipeTitle}
                        //     selectedRecipeId={selectedRecipeId}
                        //     setSelectedRecipeId={setSelectedRecipeId}
                        // />
                        <UpdateRecipeComponent
                            id={recipe._id}
                            title={recipe.recipeName}
                            image={recipe.recipeImage}
                            onClick={() => {
                                setOpen(true);
                                setSelectedRecipeTitle(recipe.recipeName);
                                setSelectedRecipeId(recipe._id);
                            }}
                            isDeleted={recipe.isDeleted}
                        />
                    )
                })
            }
            {
                <Modal
                    BackdropProps={{
                        style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' } // Şeffaf arka plan
                    }}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    open={open}
                    onClose={handleClose}>
                    <Box sx={style}>
                        <Typography variant="h6" component="h2">
                            Are You Sure?
                        </Typography>
                        <Typography sx={{ mt: 2 }}>
                            You are going to delete this blog. <a className='font-bold text-black'>{selectedRecipeTitle}</a>
                        </Typography>
                        <div
                            className='flex justify-evenly items-center mt-24 w-full'
                        >
                            <Button
                                onClick={async () => {
                                    // await deleteBlog(selectedBlogId);
                                    deleteRecipe(selectedRecipeId);
                                    handleClose();
                                }}
                                color='error'
                                variant='contained'
                                className='mt-4 ml-4 w-32'>
                                Delete
                            </Button>
                            <Button
                                onClick={handleClose}
                                variant='outlined'
                                className='mt-4 w-32'>
                                Cancel
                            </Button>
                        </div>
                    </Box>
                </Modal >
            }
        </div>
    )
}
